import { Goal, Layers, Bomb } from 'lucide-react'
import type { ChipId } from '../types'

// The one place a chip's icon is chosen. Every surface that draws a chip reads this map, so the
// icon can't drift between the chip row, the picker rows, the results modal heading, the profile
// records, the GW Points card, and the grid header's counters.
export const CHIP_ICONS: Record<ChipId, typeof Layers> = {
  doubleUp: Layers,
  goalfest: Goal,
  cleanSweep: Bomb,
}
